<!-- <div class="bg-[#F9FAFE] py-3 px-2 fixed w-full top-[67px] z-10 dark:bg-black-500">
    <div class="custom-container flex items-center justify-between">
      <button class="flex items-center text-dark-500 font-bold uppercase dark:text-white"
        (click)="onNavigateToHome()">
        <mat-icon class="material-symbols-outlined !h-[18px] !w-[18px] text-lg leading-[18px] dark:text-white">
          arrow_back_ios </mat-icon>Back
      </button>
    </div>
  </div> -->
<div class="custom-container">
  @if (influencerDetails$ | async; as influencer) {
  <vota-influencer-profile-card [profile]="influencer"></vota-influencer-profile-card>

  <mat-tab-group class="tab-custom">
    <mat-tab label="Raffles">
      @if(influencerLatestPoll) {
      <div class="">
        <vota-latest-poll [latestPoll]="influencerLatestPoll" (onCastVote)="onCastVote($event)"></vota-latest-poll>
      </div>
      }

      <!-- @if (influencerPosts$ | async; as posts) {
      @if(posts.length > 0){
      <h1 class="text-2xl font-bold mb-3 cursor-pointer" [ngClass]="{'mt-3': !influencerLatestPoll}" (click)="onNavigateToInfluencerMedia()">
        Media
      </h1>}
      <vota-media-list [posts$]="influencerPosts$" [preview]="preview"></vota-media-list>
      } -->
      <h1 class="text-2xl font-bold mb-3">Raffles</h1>
      <vota-raffles [username]="username"></vota-raffles>
    </mat-tab>
    <mat-tab label="Media">
      <vota-influencer-media [isChildView]="true"></vota-influencer-media>
    </mat-tab>
    <mat-tab label="AI Games">
      <div class="text-center p-4 text-lg">AI Games - Coming Soon!</div>
    </mat-tab>
  </mat-tab-group>

  } @else if(isLoading){
  <div class="flex items-center justify-center min-h-[calc(100vh-135px)]">
    <mat-progress-spinner mode="indeterminate" diameter="40" color="primary">
    </mat-progress-spinner>
  </div>
  } @else {

  <div class="flex flex-col items-center justify-center h-[calc(100vh-135px)]">
    @if(username){
    <div class="text-center mb-5">{{ username }} does not exist</div>
    }
    <button (click)="onBackToHome()" class="pink-btn-light !px-4">
      Back To Home
    </button>
  </div>
  }
</div>